module.exports = __webpack_public_path__ + "static/media/waypoint_o.b71a0bc3.svg";